import { render } from "./TheMarketClosedTip.vue?vue&type=template&id=d2512634&scoped=true&ts=true"
import script from "./TheMarketClosedTip.vue?vue&type=script&lang=ts"
export * from "./TheMarketClosedTip.vue?vue&type=script&lang=ts"

import "./TheMarketClosedTip.vue?vue&type=style&index=0&id=d2512634&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2512634"]])

export default __exports__